import { InjectionToken, inject } from '@angular/core';
import { EmailHubService } from './email.hub.service';

export const EMAIL_SIGNALR_HUB = new InjectionToken<EmailHubService>(
    'EMAIL_SIGNALR_HUB',
    {
        providedIn: 'root',
        factory: () => inject(EmailHubService),
    },
);
